module.exports = __webpack_public_path__ + "static/img/icon-wechatpay-full.482a1234.png";